"use strict";

// Side-effect import, same shape as easy-pick.js's `import '../libs/local/easypick/…'`.
// Defines window.KzmCal. Adjust the path to wherever KzmCal.js lands in the bundle.
import '../libs/local/kzmCal/KzmCal.min.js';

// The calendar's wording, read off `data-i18n` on the container instead of a
// German/English table compiled into this bundle. See kzm-i18n.js.
import { readI18n, readLocale } from '../libs/local/kzmCal/kzm-i18n.min.js';

/*
 * portal-search-bar.js — KzmCal edition.
 *
 * Merges the two modules the start page used to load:
 *   current_src/portal-search-bar.js  search-bar chrome (kept as-is)
 *   easy-pick.js                      the easepick date-range driver (replaced)
 *
 * Only the start page is covered here: no availability data, min-stay enforced
 * client-side. The property page (easy-pick-blocked.js) is a separate job.
 *
 * See PORTAL-SEARCH-BAR.md for how the original pair worked and which bits of
 * the DOM contract are load-bearing.
 */

/* ========================================================================
 * Calendar — replaces easy-pick.js
 * ====================================================================== */

// easepick counted whole days (minDays 30); KzmCal counts nights.
var KZM_MIN_DAYS = 30;
var KZM_MIN_NIGHTS = KZM_MIN_DAYS - 1;
// LockPlugin.maxDays — KzmCal's `maxNights`, which counts nights the same way.
var KZM_MAX_DAYS = 364;
var KZM_MIN_DATE = "2024-07-16";

function initCalendars($scope) {
    var mobileBreakpointXs = 768;

    $scope.find(".js-easypicker-container").each(function () {
        var myself = $(this);
        if (myself.hasClass("initialized")) {
            return true;
        }
        myself.addClass("initialized");

        var ismobile = myself.data("ismobile") === 1;
        // Wording for the blocked half of the hover tooltip. easepick never
        // needed these on the start page — nothing surfaced a block reason
        // there — so the markup carried no attribute for them. It does now:
        // `data-i18n` on this container, filled by Twig from Pimcore.
        var lang = readLocale(myself);
        var t = readI18n(myself, lang);

        var dateFromContEl = myself.find(".easypick-from-container");
        var dateToContEl = myself.find(".easypick-to-container");
        var dateFromEl = dateFromContEl.find(".easypick-from");
        var dateToEl = dateToContEl.find(".easypick-to");
        var dateFromHiddenEl = dateFromContEl.find(".easypick-from__hidden");
        var dateToHiddenEl = dateToContEl.find(".easypick-to__hidden");
        var dateFromCloseEl = dateFromContEl.find(".easypick-close");
        var dateToCloseEl = dateToContEl.find(".easypick-close");

        var nightsCont = myself.find(".nights-container");
        var nightsEl = nightsCont.find(".nights-val");

        var showAllEl = myself.find(".mobile-search-someinfo");
        var showAllElSpan = showAllEl.find("span:first");
        var showAllElPh = showAllElSpan.data("placeholder");

        /* ----- mount -------------------------------------------------- */
        /*
         * KzmCal wipes and owns its mount, and the site's own wrapper here is
         * already `.js-easypicker-container` — mounting on it would delete the
         * input fields. Desktop reuses the existing (hidden) `.js-easypick-wrapper`,
         * which easy-pick.js also relocated so the panel spans the whole bar;
         * mobile has no such element, so make one.
         */
        var jsEpWrapper = myself.find(".js-easypick-wrapper");
        var mountEl = $('<div class="js-kzm-cal-mount"></div>');
        if (!ismobile) {
            if (jsEpWrapper.length <= 0) {
                jsEpWrapper = $('<div class="js-easypick-wrapper" style="display:none"></div>').appendTo(myself);
            }
            jsEpWrapper.parents(".portal-search-desktop:first").append(jsEpWrapper);
            mountEl.appendTo(jsEpWrapper);
        } else {
            // Directly after the sticky header, not appended to the end of the
            // collapse — the two d-none position inputs live down there.
            var stickyWrapper = myself.find(".mobile-search-fromto-wrapper");
            if (stickyWrapper.length > 0) {
                mountEl.insertAfter(stickyWrapper);
            } else {
                mountEl.appendTo(myself);
            }
            jsEpWrapper = mountEl.parent();
        }

        var calendarsNr = 2;
        var gridNr = 2;
        if (ismobile) {
            calendarsNr = 6;
            gridNr = screen.width >= mobileBreakpointXs ? 2 : 1;
        }

        var footerInfoStr = "";
        if (!ismobile) {
            // Mobile already carries a hard-coded .footer-info in its markup.
            footerInfoStr = myself.data("footer-info") || "";
            footerInfoStr = footerInfoStr.replace(
                "%minNights%",
                '<span class="min-nights">' + KZM_MIN_NIGHTS + "</span>"
            );
        }

        /* ----- value formatting --------------------------------------- */
        var monthFmt = new Intl.DateTimeFormat(lang, { month: "short" });

        // easepick used the literal format "D. MMM. YYYY" for every language,
        // so the separators must not come from the locale.
        var formatDisplay = function (isoStr) {
            if (!isoStr) {
                return "";
            }
            var parts = isoStr.split("-");
            var d = new Date(+parts[0], +parts[1] - 1, +parts[2]);
            return d.getDate() + ". " + monthFmt.format(d) + ". " + d.getFullYear();
        };

        // The trailing time is required: the site's search reads these hidden
        // fields and its date handling breaks on a bare YYYY-MM-DD.
        var formatHidden = function (isoStr) {
            return isoStr ? isoStr + "T00:00:00" : "";
        };

        /* ----- input plumbing ----------------------------------------- */
        var currDateFrom = null;
        var currDateTo = null;

        var updateSomeInfo = function () {
            if (!ismobile) {
                return;
            }
            var dateFromStr = dateFromEl.val();
            var dateToStr = dateToEl.val();
            if (dateFromStr && dateToStr) {
                showAllElSpan.text(dateFromStr + " - " + dateToStr);
            } else if (dateFromStr) {
                showAllElSpan.text(dateFromStr + " - ");
            } else {
                showAllElSpan.text(showAllElPh);
            }
        };

        var setDateFromEls = function (isoStr) {
            currDateFrom = isoStr;
            dateFromCloseEl.removeClass("hidden");
            dateFromEl.val(formatDisplay(isoStr));
            dateFromEl.trigger("change");
            dateFromHiddenEl.val(formatHidden(isoStr));
        };
        var clearDateFromEls = function () {
            currDateFrom = null;
            dateFromCloseEl.addClass("hidden");
            dateFromEl.val("");
            dateFromEl.trigger("change");
            dateFromHiddenEl.val("");
        };
        var setDateToEls = function (isoStr) {
            currDateTo = isoStr;
            dateToCloseEl.removeClass("hidden");
            dateToEl.val(formatDisplay(isoStr));
            dateToEl.trigger("change");
            dateToHiddenEl.val(formatHidden(isoStr));
        };
        var clearDateToEls = function () {
            currDateTo = null;
            dateToCloseEl.addClass("hidden");
            dateToEl.val("");
            dateToEl.trigger("change");
            dateToHiddenEl.val("");
        };

        /*
         * The server pre-fills the hidden inputs, but easy-pick.js deliberately
         * never applied them (`if (preSelectedFrom && preSelectedTo && false)`),
         * so the picker opened empty. Blank them to match, rather than passing
         * an initialRange.
         */
        clearDateFromEls();
        clearDateToEls();
        nightsCont.hide();
        updateSomeInfo();

        /* ----- the picker --------------------------------------------- */
        var cal = new KzmCal({
            mount: mountEl[0],
            containerClass: "kzm-cal-panel",
            locale: lang,
            nightsLocale: t.nights,
            minStayLabel: t.minStay,
            maxStayLabel: t.maxStay,
            unavailableLabel: t.unavailable,
            // Was never passed here, so a departure-only cell fell through to
            // KzmCal's English default on a German page.
            departureOnlyLabel: t.departureOnly,
            minNights: KZM_MIN_NIGHTS,
            // Stands in for easepick's LockPlugin.maxDays. A check-out further
            // out than this is blocked and the hover pill says why, the way the
            // min-stay days do.
            maxNights: KZM_MAX_DAYS,
            minDate: KZM_MIN_DATE,
            calendars: calendarsNr,
            footerInfoHTML: footerInfoStr,
            // Replaces easepick's RangePlugin.tooltipNumber (nr => nr - 1);
            // KzmCal counts nights already, so the count needs no conversion.
            rangeTooltip: true
        });

        // KzmCal derives its column count from the month count. Mobile wants
        // six months stacked two-up, so override the grid it set for itself.
        if (ismobile) {
            cal.on("render", function (e) {
                $(e.container).find(".js-easypicker-wrapper")
                    .css("--ep-cals", String(gridNr));
            });
            mountEl.find(".js-easypicker-wrapper").css("--ep-cals", String(gridNr));
        }

        /* ----- panel visibility (desktop) ----------------------------- */
        var showPanel = function () {
            if (!ismobile) {
                jsEpWrapper.show();
            }
        };
        if (!ismobile) {
            /*
             * Capture phase, deliberately. KzmCal rebuilds the grid inside its
             * own click handler, so a day or nav button is already detached
             * from the document by the time a bubbling listener sees it —
             * `closest()` then finds nothing and every pick looks like an
             * outside click. easepick never hit this: it rendered into a shadow
             * root, so `e.target` retargeted to the still-attached host.
             * Capture runs before the re-render, while the DOM is intact.
             */
            document.addEventListener("click", function (e) {
                var t = e.target;
                if (!t || !t.closest) {
                    return;
                }
                /*
                 * Scoped to the mount, not to `.js-easypick-wrapper`: the
                 * wrapper is as wide as the whole search bar, so exempting it
                 * left a dead band around the calendar card where clicks did
                 * nothing. `.js-easypicker-container` stays exempt — that is
                 * the from/to fields, which must keep working while open.
                 */
                if (t.closest(".js-easypicker-container") || t.closest(".js-kzm-cal-mount")) {
                    return;
                }
                jsEpWrapper.hide();
            }, true);
        }

        /* ----- scroll the pull-up to a day (mobile) ------------------- */
        var scrollToDay = function (selector) {
            if (!ismobile) {
                return;
            }
            var pullup = $(".portal-search-mobile-pullup");
            // KzmCal puts first-available on `.day` itself; easepick had it on
            // the inner `.border-radius`.
            var jumpEl = mountEl.find(selector).first();
            if (jumpEl.length > 0) {
                pullup.animate(
                    { scrollTop: pullup.scrollTop() + jumpEl.offset().top - 220 },
                    500
                );
            } else {
                pullup.animate({ scrollTop: 0 }, 500);
            }
        };

        /* ----- events ------------------------------------------------- */
        cal.on("preselect", function (d) {
            setDateFromEls(d.start);
            clearDateToEls();
            nightsCont.hide();
            updateSomeInfo();
            // easy-pick.js's doSelection: desktop jumps the view to the
            // check-in's month, mobile scrolls to the first legal check-out.
            if (ismobile) {
                scrollToDay(".day.first-available");
            } else {
                cal.gotoDate(d.start);
            }
            // …then hands the user over to the check-out field.
            dateToEl.trigger("click");
        });

        cal.on("select", function (d) {
            setDateFromEls(d.start);
            setDateToEls(d.end);
            nightsEl.text(d.nights);
            nightsCont.show();
            updateSomeInfo();
            // A complete range puts the highlight back on the check-in field.
            dateFromEl.trigger("focus");
        });

        cal.on("clear", function (d) {
            if (d.what === "all") {
                clearDateFromEls();
            }
            clearDateToEls();
            nightsCont.hide();
            updateSomeInfo();
        });

        /* ----- field wiring ------------------------------------------- */
        // Click, not focus: the fields are readonly so a click focuses them
        // natively, and the chrome's own `.form-control` focus handler still
        // gets to run for the gray/white styling.
        /*
         * Each handler focuses its own field, so that triggering a click on it
         * — which is how the handover below moves the user along — also moves
         * the chrome's gray/white highlight. Same trick as easy-pick.js's
         * trailing `$(this).trigger("focus")`.
         */
        dateFromEl.on("click", function () {
            showPanel();
            cal.setMode("from");
            if (currDateFrom) {
                cal.gotoDate(currDateFrom);
                scrollToDay(".day.start");
            }
            $(this).trigger("focus");
        });
        dateToEl.on("click", function (e) {
            e.preventDefault();
            showPanel();
            cal.setMode("to");
            if (currDateTo) {
                cal.gotoDate(currDateTo);
                scrollToDay(".day.end");
            } else if (currDateFrom) {
                scrollToDay(".day.first-available");
            }
            $(this).trigger("focus");
        });

        dateFromCloseEl.on("click", function () {
            cal.clear();
            dateFromEl.trigger("click");
        });
        dateToCloseEl.on("click", function () {
            // clearEnd keeps the check-in and drops back into check-out mode.
            cal.clearEnd();
            // Original fell back to the check-in field when there was no start.
            if (cal.getStartDate()) {
                dateToEl.trigger("click");
            } else {
                dateFromEl.trigger("click");
            }
        });

        myself.data("kzmCal", cal);
    });
}

/* ========================================================================
 * Search-bar chrome — unchanged from current_src/portal-search-bar.js except
 * where noted
 * ====================================================================== */

export function initInScope ($scope) {
    // let container = $(".portal-search.d-none"); //only init desktop
    var mobileBreakpointXs = 768;
    var mobileBreakpoint = 992;
    var isMobile = screen.width <= mobileBreakpoint;

    var headerOffset = 70;
    headerOffset = $("header:first").outerHeight();
    // console.log("headerOffset");
    // console.log(headerOffset);
    let dtContainer = $scope.find(".portal-search-desktop .portal-search-container");
    dtContainer.find(".form-control").each(function (e) {
        $(this).on("focus", function (e) {
            dtContainer.addClass("gray");
            let allFormGroups = dtContainer.find(".form-group-inline");
            allFormGroups.removeClass("white");
            allFormGroups.removeClass("nodashed-border");

            let closestFormGroup = $(this).closest(".form-group-inline");
            let thisIndex = allFormGroups.index(closestFormGroup[0]);

            allFormGroups.each(function (i, e) {
                if(i === thisIndex - 1) {
                    $(this).addClass("nodashed-border");
                }
            });

            $(this).parents(".form-group-inline:first").addClass("white");
        });
    });
    dtContainer.find(".js-places-autocomplete").each(function (e) {
        $(this).on("focus", function (e) {
            $(this).attr("placeholder", $(this).data("focus-ph"));
        }).on("blur", function (e) {
            $(this).attr("placeholder", $(this).data("init-ph"));
        });
    });
    let mbContainer = $scope.find(".portal-search-mobile");
    mbContainer.find(".portal-search-click").on("click", function (e) {

    });

    var pullup = $(".portal-search-mobile-pullup");
    var fromToWrapper = pullup.find('.mobile-search-fromto-wrapper');
    // var fromToWrapper = pullup.find('.js-easypicker-container');
    var fixmeTop = fromToWrapper.offset().top;
    let slInput = pullup.find("#search-location .js-places-autocomplete.tt-input");
    let firstClick = true;
    $(".portal-search-mobile").on("click", function (e) {
        if(pullup.hasClass("open")) {
            $("body").removeClass("modal-open");
            pullup.removeClass("open");
        } else {
            $("body").addClass("modal-open");
            pullup.addClass("open");
            if(firstClick) {
                firstClick = false;
                pullup.find("#search-location").collapse("show");
                slInput.focus();
            }

        }
    });
    $(".portal-search-mobile-pullup .portal-search-close").on("click", function (e) {
        $("body").removeClass("modal-open");
        pullup.removeClass("open");
        return false;
    });


    //desktop person plusminus
    let portalSearchHiddenPersons = $scope.find(".portal-search-desktop .portal-search-persons .portal-search__person-select");
    $(".portal-search-desktop .portal-search-persons").on("click", function (e) {
        portalSearchHiddenPersons.show();
    });
    // Capture phase for the same reason as the calendar's outside-click above:
    // KzmCal re-renders during the click, so a bubbling listener would see a
    // detached e.target and wrongly clear the gray/white field highlight on
    // every date pick. Logic below is otherwise unchanged.
    document.addEventListener("click", function (e) {
        let $t = $(e.target);
        if($t.closest(".portal-search-persons").length === 0 && $t.closest(".portal-search__person-select").length === 0) {
            portalSearchHiddenPersons.hide();
        }
        if($t.closest(".portal-search-desktop").length === 0) {
            dtContainer.removeClass("gray");
            dtContainer.find(".form-group-inline").removeClass("white");
        }

    }, true);

    $scope.find(".portal-search__person-select").each(function () {
        let dummyEl = $(this).parent().find("input.dummy");
        let hiddenInputEl = $(this).parent().find("input.persons-hidden");
        let personsLocale = $(this).data("locale");
        let personLocale = $(this).data("locales");
        let personInput = $(this).find("input");
        let minPersons = $(this).data("min");
        let maxPersons = $(this).data("max");
        $(this).find(".add").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value < maxPersons) {
                personInput.val(value + 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
        });
        $(this).find(".sub").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value > minPersons) {
                personInput.val(value - 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
        });
    });

    if(!isMobile) {
        dtContainer.find('input').on('keydown', function(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault(); // Prevents form submission
            }
        });
    } else {
        // let ftSomeInfo = pullup.find(".js-easypicker-container .mobile-search-someinfo");
        let ftCollapseHeadline = pullup.find(".js-easypicker-container .portal-search-mobile-collapse");
        let ftCollapseHeadlineSecond = pullup.find(".js-easypicker-container .portal-search-mobile-collapse").eq(1);
        let resetFilterButton = pullup.find(".mobile-filter-reset");
        let submitButton = pullup.find(".mobile-filter-submit");
        let nextButton = pullup.find(".mobile-filter-next");

        pullup.find("#search-fromto").on("show.bs.collapse", function (e) {
            pullup.find("#search-location").collapse("hide");
            ftCollapseHeadline.hide();
            ftCollapseHeadlineSecond.show();

            submitButton.hide();
            nextButton.show();
        });
        pullup.find("#search-fromto").on("shown.bs.collapse", function (e) {
            fixmeTop = fromToWrapper.offset().top;
        })
        pullup.find("#search-fromto").on("hide.bs.collapse", function (e) {
            // console.log("hidden");
            fromToWrapper.removeClass("fixed");
            ftCollapseHeadline.show();
            ftCollapseHeadlineSecond.hide();

            submitButton.show();
            nextButton.hide();
        });

        let slSomeInfo = pullup.find(".portal-search-location .mobile-search-someinfo");
        let slDefaultLocations = pullup.find(".portal-search-location .mobile-search-defaults-locations");
        let slSomeInfoSpan = slSomeInfo.find("span");
        pullup.find("#search-location").on("show.bs.collapse", function (e) {
            slSomeInfo.hide();
            slDefaultLocations.show();
            pullup.find("#search-fromto").collapse("hide");

            submitButton.hide();
            nextButton.show();
        });
        // pullup.find("#search-location").on("shown.bs.collapse", function (e) {
        //     if(!slInput.val()) {
        //         // slInput.trigger("focus");
        //     }
        // });
        pullup.find("#search-location").on("hide.bs.collapse", function (e) {
            if(slInput.val().length <= 0) {
                slSomeInfoSpan.text(slSomeInfoSpan.data("placeholder"));
            } else {
                slSomeInfoSpan.text(slInput.val());
            }

            slSomeInfo.show();
            slDefaultLocations.hide();
            submitButton.show();
            nextButton.hide();
        });
        pullup.find('input').on('keydown', function(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault(); // Prevents form submission
                nextButton.trigger("click");
            }
        });
        pullup.find(".portal-search-location .twitter-ta-location").on("click", function (e) {
            // console.log("clicking location")
            let optionContent = $(this).find(".option").text();
            // console.log(optionContent);
            slInput.val(optionContent);
            slInput.trigger("change");
        });
        pullup.scroll(function () {                  // assign scroll event listener
            if (pullup.hasClass("open")) {
                var currentScroll = pullup.scrollTop() + headerOffset; // get current position
                // console.log(currentScroll);
                // console.log(fixmeTop);
                if (currentScroll >= fixmeTop) {           // apply position: fixed if you
                    // console.log("got fixed");
                    fromToWrapper.addClass("fixed");
                    /*
                     * Reserve the height the sticky header just took out of
                     * flow, on `.js-kzm-cal-mount` — the padding-free div that
                     * sits directly under it, i.e. the structural stand-in for
                     * easepick's `.easepick-wrapper`.
                     *
                     * Not `.js-easypicker-wrapper`: that is KzmCal's inner
                     * month grid, two levels down and carrying `padding: 10px`
                     * of its own. The `=== "0px"` guard below means "not yet
                     * compensated", so a non-zero default silently disables it
                     * on the way down, and the else branch then overwrites the
                     * real 10px — which is what made the pull-up jump.
                     */
                    if(pullup.find(".js-kzm-cal-mount").css("padding-top") === "0px") {
                        pullup.find(".js-kzm-cal-mount").css("padding-top", fromToWrapper.outerHeight() + "px");
                    }
                } else {
                    // console.log("aint got no fixed");
                    fromToWrapper.removeClass("fixed");
                    pullup.find(".js-kzm-cal-mount").css("padding-top", "0px");
                }
            } else {
                // console.log("aint got no open");
            }
        });
        resetFilterButton.on("click", function (e) {
            e.preventDefault();
            pullup.find(".easypick-from-container .easypick-close").trigger("click");
            // console.log("twitter");
            // console.log(pullup.find(".js-places-autocomplete"));
            pullup.find(".js-places-autocomplete").typeahead('val', null);
            slSomeInfoSpan.text(slSomeInfoSpan.data("placeholder"));
            pullup.find(".portal-search__person-select input").val("");

            pullup.find("#search-location").collapse("hide");
            pullup.find("#search-fromto").collapse("hide");
            pullup.animate({ scrollTop: 0 }, 500);

            resetFilterButton.hide();
            return false;
        });
        // console.log("setting on changes");
        // console.log(pullup.find(".form-control"));
        let allInputs = pullup.find(".form-control:not(.tt-hint)");
        allInputs.on("change", function(e) {
            let dirty = false;
            allInputs.each(function () {
                if($(this).val()) {
                    dirty = true;
                }
            });
            if(dirty) {
                resetFilterButton.show();
            }
        });
        nextButton.on("click", function (e) {
            e.preventDefault();
            let sLoc = pullup.find('[data-target="#search-location"]');
            let sLocEl = pullup.find('#search-location');
            let sFT = pullup.find('[data-target="#search-fromto"]');
            let sFTEl = pullup.find('#search-fromto');
            if(!sLoc.hasClass("collapsed")) {
                sLocEl.collapse("hide");
                sFTEl.collapse("show");
            } else if(!sFT.hasClass("collapsed")) {
                sFTEl.collapse("hide");
            }
            return false;
        });
    }

    // Was easy-pick.js, loaded as its own module. Runs last so the chrome's
    // handlers are bound before the pickers start firing events.
    initCalendars($scope);
}
